// import React  from "react";
import React, { useState } from "react";
import  '../../HumanResource/css/HumanResource.css';
import arrow_D from '../../HumanResource/img/ep_arrow-down-bold.png';
import arrow_U from '../../HumanResource/img/ep_arrow-up-bold.png';
import Text from '../../../common/Text.js';

 
 function FAQ_Card(props){
      // 
      //관리자인지 아닌지 버튼 visible처리
      const [isShow, setIsshow] = useState(false);

      //제목 텍스트 색상 변경
      const [text_Clr, setText_Clr] = useState('#222222');
      //구분 변경
      const [text_G, setText_G] = useState(props.Gbn);
      //제목 변경
      const [text_T, setText_T] = useState(props.Title);
      //내용 변경
      const [text_C, setText_C] = useState(props.Content);


      //편집 버튼 클릭 
      function ClickEdit()
      {
         setIsshow(true);

         const elemtId = document.getElementById('btnEdit');
         const ContentsId = document.getElementById(props.elemt);
         const imageID = document.getElementById(props.imgId);

         if(elemtId.innerText == '편집')
            {elemtId.innerText  = '취소';
              setIsshow(true);}
         else 
            {elemtId.innerText  = '편집';
              setIsshow(false);}

      }

      
      const handleChange_G = (e) => {
        setText_G(e.target.value);
      };
      const handleChange_T = (e) => {
        setText_T(e.target.value);
      };
      const handleChange_C = (e) => {
        setText_C(e.target.value);
      };


      function ShowCnts( elemt , imageid) {
        
        const TitleId = document.getElementById('TitleId');
        const elemtId = document.getElementById(elemt);
        const imageID = document.getElementById(imageid);
        console.log(elemt);
        console.log(imageID);

        setText_Clr('#222222');

        // btn1 숨기기 (display: none)
        if(elemtId.style.display !== 'none') {
            elemtId.style.display = 'none';
            imageID.src = arrow_D;
            setText_Clr('#222222');
         //   setImageSrc(arrow_D);
        }
        // btn` 보이기 (display: block)
        else {
            elemtId.style.display = 'block';
            imageID.src = arrow_U;
            setText_Clr('#0C4DA2');
           // setImageSrc(arrow_U);
        }

        
      }

      function ChangeTitleColor_E ()
      {
        const imageID = document.getElementById(props.elemt);
        
        if(imageID.style.display == 'none')
            setText_Clr('#0C4DA2');
      }

      function ChangeTitleColor_L ()
      {
        const imageID = document.getElementById(props.elemt);

        console.log(imageID.style.display);
        if(imageID.style.display !== 'block')
          setText_Clr('#222222');
      }


        return (
        <div >
              {/* <img className="img" src={props.imgsrc}  onClick={() => displayMap(props.mapid)} width='300' height='200'/>  */}
              <div >
              <Text variant="px16" >
              {isShow === false ? <p className="Gbn1" id='GbnID'>{props.Gbn}</p> : <p className="Gbn2">{props.Gbn}</p>}
              </Text>
              <div className="TitleIMG" onClick={() => ShowCnts(props.elemt, props.imgId)} >
                        <Text variant="px24w600" style={{width:'100%'}} >
                        {isShow === false ? <div  className="Title1" id= "TitleId"   onMouseEnter={() => ChangeTitleColor_E()}  onMouseLeave={() => ChangeTitleColor_L()}  style = {{color : text_Clr , cursor : "pointer"}}>{props.Title}</div> : <input type="text" value={text_T} className="Title2" onChange={handleChange_T}></input>}
                        </Text>
                        <div>
                          <img id = {props.imgId}    className ='FAQarrow' src={arrow_D}></img>
                        </div>
                          
              </div>
                        {props.auth == 'Admin' ?  <button id='btnEdit' className='btnEdit' onClick={ClickEdit} >편집</button> : ''}
                        {props.auth == 'Admin' ?  <button id='btnDelt' className='btnDelt' >삭제</button> : ''}  
                        <Text variant="px20" >
                        {isShow === false ? <p id={props.elemt} style={{ display: 'none' }}   className="Answer">{props.Content}</p> 
                                          : <input id={props.elemt} type="text" style={{ display: 'none' }}  value={text_C} className="Content2" onChange={handleChange_C}></input>}
                        </Text>                
                       

              <div className='squere2'> </div> 
                    
              </div>

              
        </div>
                
      );
     }

 
    export default FAQ_Card;